// @ts-check
import { z } from 'zod';

import GlobalMeta from '@/store/modules/models/global/Meta';

const MetaImportedRowsCsv = GlobalMeta.extend({
  headings: z.array(z.object({
      title: z.string(),
      field: z.string(),
    })),
});

export default MetaImportedRowsCsv;
